import { Component, Input, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'confirmation-modal-token',
    templateUrl: './modal-confirmacion-token.component.html'
})
export class ConfirmationModalTokenComponent implements OnInit {


    constructor(public activeModal: NgbActiveModal

    ) { }

    ngOnInit() {
    }


    close() {
        this.activeModal.close();
    }

}
